export default __webpack_public_path__ + "static/media/huawei.c0d90ee7.jpg";